export const onServiceWorkerUpdateReady = () => {
  if (process.env.FORCE_RELOAD) {
    return window.location.reload();
  }
};
